'use es6';

import { createAction } from 'redux-actions';
import { THREAD_STATUS_UPDATED } from '../constants/actionTypes';

/** Thread status updated via pubsub action */
export const threadStatusUpdated = createAction(THREAD_STATUS_UPDATED, (message, threadId) => ({
  message,
  threadId
}));